module.exports = __webpack_public_path__ + "static/media/wating_back_1d39f2cfd8692640d478d65e3fe3ea4b1.webp";